var React = require('react');

function Location (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 16C8.68629 16 6 13.3137 6 10C6 6.68629 8.68629 4 12 4C15.3137 4 18 6.68629 18 10C18 13.3137 15.3137 16 12 16Z","fill":"white","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M22 10C22 16.0078 15.6223 21.3487 13.0534 23.2562C12.4206 23.7261 11.5794 23.7261 10.9466 23.2562C8.37775 21.3487 2 16.0078 2 10C2 4.47715 6.47715 0 12 0C17.5228 0 22 4.47715 22 10ZM6 10C6 13.3137 8.68629 16 12 16C15.3137 16 18 13.3137 18 10C18 6.68629 15.3137 4 12 4C8.68629 4 6 6.68629 6 10Z","fill":"#0088BF","key":1})]);
}

Location.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Location;

Location.default = Location;
